import React, { useRef, useState } from "react";
//@ts-ignore
import style from "./styles/selectWrapper.module.css";
import Item from "./component/Item";
import useWhenClickOutsideBox from "./hooks/useWhenClickOutSideBox";
import { v4 as uuidv4 } from "uuid";
import { ISelectWrapperProps } from "./interfaces/selectWrapper";

const selectItemsDefault = [];

const uuid = uuidv4();

const SelectWrapper = ({
  children,
  selectItems = selectItemsDefault,
  selectId = uuid,
  testId,
}: ISelectWrapperProps) => {
  const menuListRef = useRef(null);
  const [showMenuList, setShowMenuList] = useState(false);
  const [position, setPosition] = useState(null);

  //When click outside the box, this close the menu list
  useWhenClickOutsideBox({
    boxElementId: selectId,
    onClickOutside: () => {
      setShowMenuList(false);
    },
  });

  const handleOpenMenu = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.stopPropagation();
    const willShow = !showMenuList;
    setShowMenuList(willShow);
    setPosition(null);

    if (willShow) {
      requestAnimationFrame(() => {
        if (!menuListRef.current) return;
        const rect = menuListRef.current.getBoundingClientRect();
        const viewportWidth = document.documentElement.clientWidth;

        if (rect.right > viewportWidth) {
          setPosition({ right: 0, left: "auto" });
        }
      });
    }
  };

  return (
    <div id={selectId} className={style.selectWrapper} onClick={handleOpenMenu}>
      {children}

      <article
        className={`${style.selectWrapper__menu} ${
          showMenuList ? style.selectWrapper__menu__show : ""
        }`}
        style={{ ...position }}
        id={testId}
        ref={menuListRef}
      >
        {selectItems.map((el, i) => {
          return (
            <Item key={`${testId}-${i}`} {...el} testId={testId + "-" + i} />
          );
        })}
      </article>
    </div>
  );
};

export default SelectWrapper;
